import React from 'react';
import "./css/Accomplishment.css"
const Accomplishment = () => {
  return (
    <>
    
    <section className="accomplish container">
        <div className='accomplish-div'>
            <h3>35+</h3>
            <p>Cities</p>
        </div>
        <div className='accomplish-div'>
            <h3>200+</h3>
            <p>Hotel</p>
        </div>
        <div className='accomplish-div'>
            <h3>2k+</h3>
            <p>Reviews</p>
        </div>
        <div className='accomplish-div'>
            <h3>100+</h3>
            <p>Place</p>
        </div>
    </section>
    <section className="home-parallax container">
        
    </section>
    {/* <section className="home-sec container">
        <div className=''>
            <h2>We Arrange The Best Trip Ever Possible</h2>
            <p>Note that hackers do not crack programs for free. They inject they own tools and turn the computers of users into zombies which send spam. Also hackers use these computer for all their illegal activities. You may send all patches and cracks to virustotal.com to verify it.</p>
            <div className='home-sec-flex'>
                 <div className='home-sec-grid'>
                    <div>
                        <i className='fas fa-dollar'></i>
                    </div>
                    <div>
                        <h3>Cheap Prices</h3>
                        <p>Note that hackers do not crack programs for free. They inject they own tools.</p>
                    </div>
                 </div>
                 <div className='home-sec-grid'>
                    <div>
                        <i className='fas fa-dollar'></i>
                    </div>
                    <div>
                        <h3>Fast Bookings</h3>
                        <p>Note that hackers do not crack programs for free. They inject they own tools.</p>
                    </div>
                 </div>
            </div>
        </div>
        <div className=''>
            <img src={require('../assets/image/10.jpg')} alt="Masai Mara" />
        </div>
    </section> */}
    
    </>
  
  );
};

export default Accomplishment;
